<template>
  <form @submit.prevent="submitForm" class="site-form construct-form">

    <jur-template
        v-bind="{...this.$props, form}"
        v-if="mode === 'jur'"
    />


    <phys-template
        v-bind="{...this.$props, form}"
        v-if="mode === 'phys'"
    />

    <div class="container">
      <div class="construct-form-footer max-1032">
        <button class="btn-filled" type="submit"><span>Отправить</span></button>
        <div class="construct-form-agree">Заполняя данную форму, вы принимаете условия <a target="_blank" :href="linkAgree">Соглашения об использовании сайта</a>, и соглашаетесь с <a target="_blank" :href="linkPd">Правилами обработки и использования персональных данных</a></div>
      </div>
    </div>


  </form>


</template>

<script>
import JurTemplate from "./mode/jur-template.vue";
import PhysTemplate from "./mode/phys-template.vue";
import {ref} from "vue";
import {Fancybox} from "@fancyapps/ui";
import SuccessModal from "../../../service/SuccessModal";
import FormTransformable from "../../../service/FormTrans";
import {CustomDropdown} from "../../../block/customDropdown";

const refErrors = ref({});

const cloneForm = {
  STATEMENT: null,
  APPLICANT: null,
  AGREEMENT: null,

  APPLICANT_FAMILY: null,
  APPLICANT_NAME: null,
  APPLICANT_SECOND_NAME: null,
  APPLICANT_FULL_NAME: null,
  APPLICANT_SHORT_NAME: null,
  APPLICANT_PLACE_BIRTH: null,
  APPLICANT_REG_ADDRESS: null,
  APPLICANT_POST_ADDRESS: null,
  APPLICANT_DOB: null,

  DOCUMENT_TYPE: null,

  NUM_EGRUL: null,
  DATE_EGRUL: null,

  INN: null,
  OGRN: null,
  KPP: null,

  PHONE_1: null,
  PHONE_2: null,
  EMAIL_1: null,
  EMAIL_2: null,

  TYPE_EDO: null,

  REG_COUNTRY: null,
  REG_REGION: null,
  REG_DISTRICT: null,
  REG_CITY: null,
  REG_STREET: null,
  REG_HOME: null,
  REG_APARTMENT: null,
  REG_INDEX: null,

  reg_ident_post: null,

  POST_COUNTRY: null,
  POST_REGION: null,
  POST_DISTRICT: null,
  POST_CITY: null,
  POST_STREET: null,
  POST_APARTMENT: null,
  POST_HOME: null,
  POST_INDEX: null,

  DOCUMENT_SERIES: null,
  DOCUMENT_NUMBER: null,
  DOCUMENT_DATE: null,
  DOCUMENT_SENDER: null,
  DOCUMENT_CODE: null,

  CONFIDANT: null,
  RECEIVE_AGREEMENT: null,

  OBJECTS: [
    {},
  ],

  BANK_INFO: [
    {},
  ],

  NUMBER_AGREEMENT: null,

  OBJECT_NAME: null,
  // OBJECT_REGION: null,
  OBJECT_CITY: null,
  OBJECT_STREET: null,
  OBJECT_HOME: null,
  OBJECT_APARTMENT: null,
  OBJECT_HOUSE: null,
  OBJECT_ROOM: null,
  COUNT_ROOM: null,
  DEVICE: null,
  DURATION: null,
  ANIMAL_1: null,
  ANIMAL_2: null,
  ANIMAL_3: null,
  ANIMAL_4: null,

  OBJECT_SQUARE: null,
  OBJECT_ROOMS: null,
  OBJECT_COUNT_REGISTER: null,
  OBJECT_COUNT_FACT_ALIVE: null,
  OBJECT_COUNT_OWNER: null,


  // файлы
  FILE_STATEMENT: null,
  FILE_DRAFT_AGREEMENT: null,
  FILE_MAIN_DOCS: null,
  FILE_REG_TAX: null,
  FILE_DOC_OKVED: null,
  FILE_DOC_PERMISSION: null,
  FILE_PASSPORT_COPY: null,
  FILE_DOC_RULES: null,
  FILE_DOC_OWNER: null,
  FILE_DOC_COUNT_GARAGE: null,
  FILE_DOC_TECH_ACCEPT: null,
  FILE_ACT_ACCEPT: null,
  FILE_TECH_BOOKING_BSK: null,

  // Файлы p.2
  FILE_CERT_REG: null,
  FILE_PASSPORT: null,
  FILE_AGREEMENT: null,
  FILE_SNILS: null,
  FILE_INN: null,
  FILE_EXTRACT_HOUSE: null,
};

export default {
  name: "template-constructor",
  components: {PhysTemplate, JurTemplate},
  setup() {
  },
  data() {
    return {
      form: {
        STATEMENT: null,
        APPLICANT: null,
        AGREEMENT: null,

        APPLICANT_FAMILY: null,
        APPLICANT_NAME: null,
        APPLICANT_SECOND_NAME: null,
        APPLICANT_FULL_NAME: null,
        APPLICANT_SHORT_NAME: null,
        APPLICANT_PLACE_BIRTH: null,
        APPLICANT_REG_ADDRESS: null,
        APPLICANT_POST_ADDRESS: null,
        APPLICANT_DOB: null,

        DOCUMENT_TYPE: null,

        NUM_EGRUL: null,
        DATE_EGRUL: null,

        INN: null,
        OGRN: null,
        KPP: null,

        PHONE_1: null,
        PHONE_2: null,
        EMAIL_1: null,
        EMAIL_2: null,

        TYPE_EDO: null,

        REG_COUNTRY: null,
        REG_REGION: null,
        // REG_DISTRICT: null,
        REG_CITY: null,
        REG_STREET: null,
        REG_HOME: null,
        REG_APARTMENT: null,
        REG_INDEX: null,

        reg_ident_post: null,

        POST_COUNTRY: null,
        POST_REGION: null,
        // POST_DISTRICT: null,
        POST_CITY: null,
        POST_STREET: null,
        POST_APARTMENT: null,
        POST_HOME: null,
        POST_INDEX: null,

        DOCUMENT_SERIES: null,
        DOCUMENT_NUMBER: null,
        DOCUMENT_DATE: null,
        DOCUMENT_SENDER: null,
        DOCUMENT_CODE: null,

        CONFIDANT: null,
        RECEIVE_AGREEMENT: null,

        OBJECTS: [
          {},
        ],

        BANK_INFO: [
          {},
        ],

        NUMBER_AGREEMENT: null,

        OBJECT_NAME: null,
        // OBJECT_REGION: null,
        OBJECT_CITY: null,
        OBJECT_STREET: null,
        OBJECT_HOME: null,
        OBJECT_APARTMENT: null,
        OBJECT_HOUSE: null,
        OBJECT_ROOM: null,
        COUNT_ROOM: null,
        DEVICE: null,
        DURATION: null,
        ANIMAL_1: null,
        ANIMAL_2: null,
        ANIMAL_3: null,
        ANIMAL_4: null,

        OBJECT_SQUARE: null,
        OBJECT_ROOMS: null,
        OBJECT_COUNT_REGISTER: null,
        OBJECT_COUNT_FACT_ALIVE: null,
        OBJECT_COUNT_OWNER: null,


        // файлы
        FILE_STATEMENT: null,
        FILE_DRAFT_AGREEMENT: null,
        FILE_MAIN_DOCS: null,
        FILE_REG_TAX: null,
        FILE_DOC_OKVED: null,
        FILE_DOC_PERMISSION: null,
        FILE_PASSPORT_COPY: null,
        FILE_DOC_RULES: null,
        FILE_DOC_OWNER: null,
        FILE_DOC_COUNT_GARAGE: null,
        FILE_DOC_TECH_ACCEPT: null,
        FILE_ACT_ACCEPT: null,
        FILE_TECH_BOOKING_BSK: null,

        // Файлы p.2
        FILE_CERT_REG: null,
        FILE_PASSPORT: null,
        FILE_AGREEMENT: null,
        FILE_SNILS: null,
        FILE_INN: null,
        FILE_EXTRACT_HOUSE: null,
      },
    };
  },
  provide() {
    return {
      errors: refErrors,
      formKey: this.formKey,
    }
  },
  props: {
    action: {
      type: String,
      default: null
    },
    formKey: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: 'jur'
    },
    typeAgreement: {
      type: Object,
      default: null
    },
    typeApplicant: {
      type: Object,
      default: null
    },
    typeDocument: {
      type: Object,
      default: null
    },
    receiveAgreement: {
      type: Object,
      default: null
    },
    typeEdo: {
      type: Object,
      default: null
    },
    variantDocument: {
      type: Object,
      default: null
    },
    typeDevice: {
      type: Object,
      default: null
    },
    linkAgree: {
      type: String,
      default: null
    },
    linkPd: {
      type: String,
      default: null
    },
    propertyExtensions: {
      type: Object,
      default: null
    },
  },
  methods: {
    submitForm(event) {

      fetch(this.action, {
        method: 'POST',
        body: new FormTransformable({[this.formKey]: this.form}),
      }).then(response => response.json()).then(result => {

        let {code} = result;
        let {data} = result;

        if (code === 200) {
          new SuccessModal(this.action);
          this.resetData();
        }

        if (code === 400) {
          let {errors} = data;
          if (errors) {
            refErrors.value = errors;

            Object.keys(errors).slice(0, 1).map(key => {
              const element = document.getElementById(`field-${key}`);
              if (element) {
                element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
              }

            });
          }
        }

      });
    },
    resetData() {
      this.form = JSON.parse(JSON.stringify(cloneForm));
    }
  }
}
</script>
